import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";

// Context
import { StoreContext } from "../context/store-context";

// Components
import { AddedToCartPopup } from "./added-to-cart-popup";

const ProductButtons = styled.div`
  max-width: 400px;

  & button {
    /* font-size: 15px; */
    font-size: 12px;
    line-height: 39px;
    letter-spacing: 0.02em;
    text-align: center;

    background-color: #f5eadf;
    color: #0b646f;

    width: 100%;
    height: 40px;

    @media (hover: hover) and (pointer: fine) {
      transition: 250ms color ease, 250ms background-color ease;

      &:hover {
        color: #fff;
        background-color: #0b646f;
      }
    }

    &:disabled {
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          color: #0b646f;
          background-color: #f5eadf;
        }
      }
    }
  }

  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    z-index: 10;

    max-width: 100%;

    & button {
      font-size: 14px;
    }
  }
`;

export const AddToCart = ({
  variantId,
  quantity,
  available,
  product,
  price,
  artistName,
  hasVariantChanged,
  isPreview,
  isOnePerCustomer,
  ...props
}) => {
  const { addVariantToCart, loading, checkout } = useContext(StoreContext);
  const [addedToCart, setAddedToCart] = useState(false);
  const [isAlreadyInCart, setIsAlreadyInCart] = useState(false);

  // Check if product is already in cart
  useEffect(() => {
    if (isOnePerCustomer && checkout?.lineItems) {
      const productInCart = checkout.lineItems.find(
        item => item.variant.product.id === product.shopifyId
      );
      setIsAlreadyInCart(!!productInCart);
    }
  }, [checkout, product.shopifyId, isOnePerCustomer]);

  const addToCart = e => {
    e.preventDefault();
    if (isOnePerCustomer && isAlreadyInCart) {
      return;
    }
    addVariantToCart(variantId, quantity);
    setAddedToCart(true);
  };

  useEffect(() => {
    if (addedToCart) {
      const closeAddToCartPopup = setTimeout(() => {
        setAddedToCart(false);
      }, 5000);
      return () => clearTimeout(closeAddToCartPopup);
    }
  }, [addedToCart]);

  const buttonText = () => {
    if (!available) return "Out of Stock";
    if (addedToCart) return "Added!";
    if (isOnePerCustomer && isAlreadyInCart) return "One per customer";
    return "Add to Bag";
  };

  return (
    <>
      <ProductButtons>
        <button
          disabled={
            !available ||
            loading ||
            isPreview ||
            (isOnePerCustomer && isAlreadyInCart)
          }
          onClick={e => addToCart(e)}
          {...props}
          className="uppercase"
        >
          {buttonText()}
        </button>
      </ProductButtons>

      {addedToCart && (
        <AddedToCartPopup
          product={product}
          price={price}
          artistName={artistName}
        />
      )}
    </>
  );
};
